import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { PUSH_AUTH_ERROR, GET_USER_INFO_FAIL } from 'containers/App/constants';
import { api } from 'api/index';

export const useAuth = () => {
  const dispatch = useDispatch();
  const intervalRef = useRef();
  const stopChecking = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await api.get('/api/account/auth-check');
        if (response.data?.signin_url) {
          dispatch({ type: PUSH_AUTH_ERROR, payload: response.data.signin_url ?? '/signin' });
          stopChecking();
        }
      } catch (error) {
        dispatch({ type: GET_USER_INFO_FAIL });
        stopChecking();
      }
    };
    const visibilityChangeCheck = async () => {
      if (!document.hidden) {
        // Tab is now visible and check auth status
        checkAuth();
      };
    };
    // Check every 5 min.
    intervalRef.current = setInterval(checkAuth, 60 * 1000);
    // Check when the tab is returned to.
    document.addEventListener('visibilitychange', visibilityChangeCheck);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      document.removeEventListener('visibilitychange', visibilityChangeCheck);
    };
  }, []);
};
